import * as AppTypes from "AppTypes";
import { actionTypes } from "../actions/";

export interface ILangPack {
  [key: string]: string;
}

export type TLanguage = "EN" | "MY" | "CH" | "TH" | "ID" | "VN";

export interface IConfigState {
  lang: TLanguage;
  langPack: ILangPack;
  appConfig: IAppConfig;
  tncData: Record<string, string>;
}

export interface IAppConfig {
  api: string;
  biographyLimit: number;
  artworkDescriptionLimit: number;
  errorRetryMax: number;
  artworkSizeLimit: number;
  countryConfig: {
    [key: string]: ICountryConfig;
  };
  AATagging: {
    [key: string]: string;
  };
  clientSideKey: string;
  isCaptcha: boolean;
}
interface ICountryConfig {
  minAge: number;
  languageOptions: TLanguage[];
}

export const initialState: IConfigState = {
  lang: "EN",
  langPack: {},
  tncData: {},
  appConfig: {
    api: "",
    biographyLimit: 800,
    artworkSizeLimit: 3072000,
    errorRetryMax: 3,
    artworkDescriptionLimit: 1500,
    countryConfig: {
      SG: {
        minAge: 18,
        languageOptions: [],
      },
    },
    AATagging: {
      staging:
        "//assets.adobedtm.com/11fb0e112fbf/99561378ba54/launch-ff9c59d6547a-staging.min.js",
      production:
        "//assets.adobedtm.com/11fb0e112fbf/99561378ba54/launch-36a843b3197f.min.js",
    },
    clientSideKey: "",
    isCaptcha: true,
  },
};

let persistStore = JSON.parse(
  window.sessionStorage.getItem("application-store")
);
let persistConfig = persistStore && persistStore.config;
if (/verify=/.test(window.location.search)) {
  persistStore = undefined;
  persistConfig = undefined;
}

export const configReducer = (
  state: IConfigState = persistConfig || initialState,
  action: AppTypes.RootAction
) => {
  switch (action.type) {
    case actionTypes.UPDATE_CONFIG:
      return { ...state, ...action.payload };

    case actionTypes.UPDATE_APP_CONFIG:
      return { ...state, appConfig: { ...state.appConfig, ...action.payload } };
    default:
      return state;
  }
};
